/**
 * Calculate the end date of a quarter
 * @param year Year of the quarter
 * @param quarter Quarter (1..4)
 * @returns {string} End of the quarter in YYYY-MM-DD format
 */
export default function (year, quarter)
{
    switch (quarter)
    {
        case 1:
            return year + '-04-01';
        case 2:
            return year + '-07-01';
        case 3:
            return year + '-10-01';
        case 4:
            return (year + 1) + '-01-01';
    }
}